import { Button, DialogActions, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DISABLED_CONTROL_COLOR, VENDOR_LINK_COLOR_DARK } from '@/pages/Candidate/view/oneOffOrder/constants';
import { TURN_STYLES } from '@/styles/theme';

export const Container = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  columnGap: '24px',
  rowGap: '16px',
  width: '100%',
  marginBottom: '20px',
});

export const FieldWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  width: '100%',
  minWidth: 0,
});

export const WideField = styled(FieldWrapper)({
  gridColumn: '1 / -1',
});

export const RecordedSlot = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  minWidth: 0,
  paddingTop: 24,
});

export const FieldLabel = styled('span')(({ theme }) => ({
  fontSize: '13px',
  fontWeight: 600,
  lineHeight: '18px',
  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.neutralDark,
}));

export const RequiredMark = styled('span')({
  color: TURN_STYLES.errorDark,
  marginLeft: '2px',
});

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  width: '100%',

  '& .MuiOutlinedInput-root': {
    width: '100%',
    backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkSurfaceColor : TURN_STYLES.neutralLight,

    '&.MuiInputBase-multiline': {
      width: '100%',
      height: 'auto',
      maxHeight: 'none',
    },
  },

  '& .MuiOutlinedInput-input': {
    color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.primaryColor,
  },
}));

export const EditableTextFieldStyled = styled(TextField)({
  width: '100%',

  '& .MuiOutlinedInput-root': {
    width: '100%',
  },
});

export const OrderIdRow = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  width: '100%',
});

export const OrderIdField = styled('div')({
  flex: 1,
  minWidth: 0,
});

export const HelperText = styled('span')(({ theme }) => ({
  display: 'block',
  marginTop: '6px',
  fontSize: '12px',
  lineHeight: '16px',
  color: theme.palette.mode === 'dark' ? DISABLED_CONTROL_COLOR : TURN_STYLES.secondaryButtonColor,
}));

export const UpdateOrderButton = styled(Button)(({ theme }) => ({
  flexShrink: 0,
  height: '42px',
  whiteSpace: 'nowrap',
  fontWeight: 600,
  color: theme.palette.mode === 'dark' ? VENDOR_LINK_COLOR_DARK : TURN_STYLES.primaryAccentColor,
  borderColor: theme.palette.mode === 'dark' ? VENDOR_LINK_COLOR_DARK : TURN_STYLES.primaryAccentColor,

  '&:hover': {
    borderColor: theme.palette.mode === 'dark' ? VENDOR_LINK_COLOR_DARK : TURN_STYLES.violetDark,
    backgroundColor: TURN_STYLES.primaryAccentColorHover,
  },
}));

export const Toolbar = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  width: '100%',
  paddingTop: '16px',
  borderTop: `1px solid ${theme.palette.mode === 'dark' ? TURN_STYLES.darkBorderColor : TURN_STYLES.borderColor}`,
}));

export const DialogDescription = styled('p')(({ theme }) => ({
  margin: '0 0 16px',
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkSecondaryColor : TURN_STYLES.primaryColor,
}));

export const InfoBanner = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  marginTop: '16px',
  padding: '12px 14px',
  borderRadius: '8px',
  backgroundColor: theme.palette.mode === 'dark' ? TURN_STYLES.darkVioletLight : TURN_STYLES.violetLight,
  color: theme.palette.mode === 'dark' ? TURN_STYLES.darkVioletDark : TURN_STYLES.violetDark,
  fontSize: '13px',
  lineHeight: '18px',

  '& .MuiSvgIcon-root': {
    flexShrink: 0,
    fontSize: '18px',
    marginTop: '1px',
  },
}));

export const DialogFields = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
});

/* Resets theme MuiDialogActions purple button styles for text/cancel actions */
export const DialogActionsStyled = styled(DialogActions)({
  padding: '16px 24px',
  gap: '8px',

  '& .MuiButton-root': {
    width: 'auto',
    minWidth: '64px',
  },

  '& .MuiButton-root:not(.MuiButton-contained)': {
    backgroundColor: 'transparent',
    color: TURN_STYLES.secondaryButtonColor,
    fontWeight: 'bold',
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: 'transparent',
      color: TURN_STYLES.secondaryButtonColor,
      boxShadow: 'none',
    },

    '&.Mui-disabled': {
      backgroundColor: 'transparent',
      color: TURN_STYLES.secondaryButtonColor,
      opacity: 0.5,
    },
  },
});

export const DialogCancelButton = styled(Button)({
  fontWeight: 'bold',
  color: TURN_STYLES.secondaryButtonColor,
});

export const ConfirmUpdateButton = styled(Button)({
  backgroundColor: TURN_STYLES.primaryAccentColor,
  color: '#fff',
  fontWeight: 600,
  boxShadow: 'none',

  '&:hover': {
    backgroundColor: TURN_STYLES.violetDark,
    color: '#fff',
    boxShadow: 'none',
  },

  '&.Mui-disabled': {
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    color: 'rgba(0, 0, 0, 0.26)',
    boxShadow: 'none',
  },

  '& .MuiSvgIcon-root': {
    fontSize: '18px',
  },
});
